import Pusher from "pusher-js";
import Echo from "laravel-echo";
import {storageFunctions} from "../storage";
import {API_DOMAIN, API_SCHEMA} from "../env";

export function initiatePusherBroadcast(){
    // @ts-ignore
    window.Pusher = Pusher;
    // @ts-ignore
    window.Pusher.logToConsole = false;
    storageFunctions.getData("api_key").then(key=>{
        // @ts-ignore
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: "rrbcr56",
            cluster: 'mt1',
            auth: {
                headers: {
                    "Authorization": `Bearer ${key}`,
                }
            },
            authEndpoint: `${API_SCHEMA}${API_DOMAIN}/broadcasting/auth`,
            wsHost: `${API_DOMAIN}`,
            wsPort: 6001,
            wssPort: 6001,
            forceTLS: true,
            enabledTransports: ['ws', 'wss'],
        });
    })
}
